import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function getAllLocations() {
    const response = await axios
        .get(API_URL + "/locationmaster/getlocations")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getAllActiveLocations() {
    const response = await axios
        .get(API_URL + "/locationmaster/getactivelocation")
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function AddNewLocation(locationObj) {
    const response = await axios
        .post(API_URL + "/locationmaster/addlocation", locationObj)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function updateLocation(locationObj) {
    const response = await axios
        .post(API_URL + "/locationmaster/updatelocation", locationObj)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function checkLocationUsage(location) {
    const response = await axios
        .post(API_URL + "/locationmaster/checklocationusage", {
            Location: location
        })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: { usedInDisposal: false, usedInEnquiry: false, usedInUserMaster: false, userCount: 0 } };
        });
    return response.data;
}

export async function deleteLocation(sk, deleteType = 'logical') {
    const response = await axios
        .post(API_URL + "/locationmaster/deletelocation", {
         SK: sk,
         DeleteType: deleteType
        })
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    return response.data;
}

export async function getActiveLocationForDivision(division) {
    let url = `${API_URL}/locationmaster/locationbydivision`;
    let reqBody = { Division: division, Status: "Active" }
    const response = await axios
        .post(url, reqBody)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    console.log("response.data====>", response.data);
    return response.data;
}

export async function getAllLocationForDivision(division) {
    let url = `${API_URL}/locationmaster/locationbydivision`;
    let reqBody = { Division: division }
    const response = await axios
        .post(url, reqBody)
        .then(function (resp) {
            return resp;
        })
        .catch(function (error) {
            console.log("error => ", error);
            return { data: [] };
        });
    console.log("response.data====>", response.data);
    return response.data;
}